module.exports = __webpack_public_path__ + "static/media/cotizacion.92c14243.svg";